export default __webpack_public_path__ + "static/media/delete_white.00f17e07.svg";